// src/pages/DharaWellnessProgram.js
import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Banner / hero image
import Banner01 from "./../assets/AyurvedaAssets/images/Dhara_Program/dharaprogram.png";

// Testimonials
import Testimonial01 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-01.png";
import Testimonial02 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-02.png";
import Testimonial03 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-03.png";

// Clients
import Client01 from "./../assets/AyurvedaAssets/images/client/client-01.png";
import Client02 from "./../assets/AyurvedaAssets/images/client/client-02.png";
import Client03 from "./../assets/AyurvedaAssets/images/client/client-03.png";
import Client04 from "./../assets/AyurvedaAssets/images/client/client-04.png";
import Client05 from "./../assets/AyurvedaAssets/images/client/client-05.png";

// CTA
import CTAImg from "./../assets/AyurvedaAssets/images/single-img-05.png";

// SVGs for 4 Dhara programs (reusing yoga SVGs)
import BeCalmImg from "./../assets/AyurvedaAssets/images/Dhara_Program/DC.png";
import BurnFatImg from "./../assets/AyurvedaAssets/images/Dhara_Program/WM.png";
import GetStrongerImg from "./../assets/AyurvedaAssets/images/Dhara_Program/PR.png";
import BecomeFlexibleImg from "./../assets/AyurvedaAssets/images/Dhara_Program/PK.png";

// REUSABLE COMPONENTS
import ServiceListing from "./Components/ServiceList";
import Pricing from "./Components/Pricing";
import PricingComparision from "./Components/PricingComparision";

export default function DharaWellnessProgram({ AllServicesListing }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  // --- Find Dhara service (id/url/name) from your main listing, if available ---
  const dharaProgram =
    AllServicesListing?.find(
      (s) =>
        s.url === "/Dhara-Wellness-Program" ||
        s.name === "Dhara Wellness Program" ||
        s.id === 8
    ) || null;

  const dharaSteps = dharaProgram?.steps || [];

  // Testimonials
  const testimonialAvatars = [
    {
      img: Testimonial01,
      name: "Christina Lois",
      role: "Wellness Program Member",
    },
    { img: Testimonial02, name: "Jessica Brown", role: "Diabetes Care Member" },
    { img: Testimonial03, name: "Kate Mason", role: "Pain Relief Member" },
  ];

  const testimonialTexts = [
    "In 90 days my energy, sleep and weight all improved. The combination of Usha Kriya, diet and regular check-ins kept me disciplined.",
    "The Dhara Diabetes Care program gave structure to my day. Instead of just increasing medicines, we worked on food, movement and stress.",
    "Pain relief was gradual but solid. My knee mobility and confidence came back. The weekly mentor calls kept me accountable.",
  ];

  const clients = [Client01, Client02, Client03, Client04, Client05];

  // 4 Dhara programs as cards (text is concise, bullets from the core idea)
  const benefitsData = [
    {
      key: "weight",
      title: "90-Day Weight Management",
      subtitle: "Daily Usha Kriya + Local Food = Visible Change",
      text: [
        "Daily Usha Kriya: 30–45 min (~200–500 kcal burn)",
        "Seasonal/local veg with ~500 kcal deficit",
        "Body composition & inch-loss tracking with mentor",
      ],
      bgColor: "rgba(173, 216, 230, 0.6)", // light blue
      img: BurnFatImg,
      colorClass: "text-success",
    },
    {
      key: "pain",
      title: "90-Day Pain Relief",
      subtitle: "Cervical • Lumbar • Knee",
      text: [
        "Snehana, Swedana, Kati/Greeva/Janu Basti protocols",
        "Daily Usha Kriya for joint alignment & breath rhythm",
        "Posture, gait & home routine guidance",
      ],
      bgColor: "rgba(255, 218, 185, 0.6)", // light peach
      img: GetStrongerImg,
      colorClass: "text-warning",
    },
    {
      key: "diabetes",
      title: "90-Day Diabetes Care",
      subtitle: "Discipline, not guesswork",
      text: [
        "Baseline & follow-up sugars / HbA1c (labs separate)",
        "Seasonal/local diet & meal-timing discipline",
        "Daily Usha Kriya + individualized Aushadhi",
      ],
      bgColor: "rgba(224, 255, 255, 0.6)", // light cyan
      img: BeCalmImg,
      colorClass: "text-primary",
    },
    {
      key: "panchakarma",
      title: "Panchakarma 7 / 11 / 15-Day",
      subtitle: "Reset. Detox. Rebuild.",
      text: [
        "Physician-led in-center detox planning",
        "Snehana, Swedana, Basti & Abhyanga-based protocols",
        "Daily Usha Kriya + pathya (regimen) for recovery",
      ],
      bgColor: "rgba(144, 238, 144, 0.6)", // light green
      img: BecomeFlexibleImg,
      colorClass: "text-success",
    },
  ];

  // --- YouTube items (Dhara / Usha Kriya content) ---
  const youtubeVideos = [
    {
      id: "dMKKFQmEYzA",
      title:
        "बिना दवा स्वस्थ, शतायु आनंदित जीवन – ऊषा क्रिया पार्ट 1 (अग्नि)",
      url: "https://www.youtube.com/watch?v=dMKKFQmEYzA",
    },
    {
      id: "dG8CLQqY4-I",
      title: "ऊषा क्रिया पार्ट 2 – संपूर्ण क्रिया परिचय",
      url: "https://www.youtube.com/watch?v=dG8CLQqY4-I",
    },
  ];

  return (
    <>
      {/* page-title */}
      <div className="custom-usha-kriya-title prt-page-title-row style2">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-8 col-lg-8">
                <div className="prt-page-title-row-heading">
                  <div className="page-title-heading">
                    <h3>Structured, mentor-led wellness</h3>
                    <h2 className="title">Dhara Wellness Program</h2>
                  </div>
                  <div className="page-title-desc">
                    <p>
                      Dhara brings together{" "}
                      <b>Daily Usha Kriya, Ayurvedic diet, herbs</b> and{" "}
                      <b>regular follow-ups</b> into clear 90-day programs and
                      short in-center Panchakarma. Discipline + nature-aligned
                      routine = sustained improvement.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4">
                <img
                  alt="Dhara Wellness Illustration"
                  src={Banner01}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* page-title end */}

      {/* site-main */}
      <div className="site-main">
        {/* About Dhara */}
        <section className="usha-kriya-about-sec container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="text-center">
                <h2>What is Dhara Wellness?</h2>
                <p>Four clear paths, one continuous discipline.</p>
              </div>
              <div className="about-card p-5">
                <div className="row">
                  <div className="col-xl-10 col-lg-10">
                    <h3>About Dhara Wellness Programs</h3>
                    <p>
                      Dhara is Bharat Dhara&apos;s{" "}
                      <b>structured wellness framework</b> built on the
                      foundation of Usha Kriya and classical Ayurveda. Instead
                      of random therapies, you choose a clear path — Weight
                      Management, Pain Relief, Diabetes Care, or Panchakarma
                      detox — and work with a mentor for 90 days (or 7/11/15
                      days in-center).
                    </p>
                    <p>
                      Every program follows a simple idea:{" "}
                      <b>daily discipline, local food, right herbs, and periodic
                        review</b>. You don&apos;t walk alone — the Dhara team
                      helps you track progress, unblock challenges, and stay
                      consistent so that results are visible and sustainable.
                    </p>
                  </div>
                  <div className="col-xl-2 col-lg-2">
                    <img
                      alt="Dhara Icon"
                      src={Banner01}
                      style={{
                        maxWidth: "460px",      // make it big enough to see clearly
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* About Dhara Ends */}

        {/* 4 Program Cards */}
        <div className="container py-5">
          <h4 className="text-center fw-bold">
            Choose Your Dhara Wellness Path
          </h4>
          <p className="text-center text-muted mb-5 pb-3">
            Each program combines Usha Kriya, pathya (diet & lifestyle), herbs
            and mentoring — tuned to your condition.
          </p>

          <div className="row g-4">
            {benefitsData.map((benefit) => (
              <div key={benefit.key} className="col-md-6 col-lg-3">
                <div
                  className="card h-100 px-4 pt-4 shadow-sm"
                  style={{ backgroundColor: benefit.bgColor }}
                >
                  <div className="text-center">
                    <h5 className={`fw-bold ${benefit.colorClass}`}>
                      {benefit.title}
                    </h5>
                    {benefit.subtitle && (
                      <p className="small text-muted mb-2">
                        {benefit.subtitle}
                      </p>
                    )}
                    <ul className="list-unstyled mt-3 mb-4">
                      {benefit.text.map((point, i) => (
                        <li key={i}>✓ {point}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="text-center" style={{ marginTop: "auto" }}>
                    <img
                      src={benefit.img}
                      alt={benefit.title}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* appointment / explanation section */}
        <section className="prt-row appointment-section01 clearfix">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="appointment-mask-wrapper">
                  <div className="appointment-mask-circle">
                    <div className="appointment-mask-image-circle"></div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="featured-content-box mt-30">
                  <div className="featured-content">
                    <div className="featured-title">
                      <h3>
                        90 Days of Disciplined Care – Not Just One-Day
                        Treatment
                      </h3>
                      <p>Plan, track, and stay accountable.</p>
                    </div>
                    <div className="featured-desc">
                      <div className="page-title-desc">
                        <p>
                          Every Dhara program starts with a{" "}
                          <b>detailed Ayurvedic consultation</b>, baseline
                          metrics and clear goals. You receive a{" "}
                          <b>program booklet, planner and follow-up schedule</b>
                          . Usha Kriya anchors your daily routine, while diet,
                          herbs and therapies are tuned to your condition.
                        </p>
                        <p>
                          Mentors check in at milestones (D0 / D30 / D60 / D90)
                          and in between if needed — so that you don&apos;t
                          fall back into old habits. The aim is simple:{" "}
                          <b>
                            sustainable change in weight, pain, sugars and
                            overall quality of life
                          </b>
                          .
                        </p>
                      </div>

                      <div className="mt-35">
                        <a
                          className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor ml-20"
                          href="contact-us.html"
                        >
                          Book your Dhara program discussion
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* featured-content-box end */}
              </div>
            </div>
          </div>
        </section>
        {/* appointment-section end */}

        {/* YouTube Videos Section */}
        <section className="prt-row clearfix" style={{ padding: "40px 0" }}>
          <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="title mb-0">Usha Kriya &amp; Dhara Videos</h2>
              <a
                href="https://www.youtube.com/@Bharatdharacares"
                target="_blank"
                rel="noreferrer"
                className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor d-none d-md-inline-block"
              >
                Watch all videos →
              </a>
            </div>

            {/* mobile: horizontal scroll */}
            <div className="d-md-none" style={{ overflowX: "auto" }}>
              <div
                className="flex gap-4 pb-2"
                style={{ display: "flex", scrollSnapType: "x mandatory" }}
              >
                {youtubeVideos.map((video) => (
                  <a
                    key={video.id}
                    href={video.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white rounded-lg flex-shrink-0 transform hover:scale-95 transition-transform duration-300 snap-center w-[328px]"
                  >
                    <img
                      src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                      alt={video.title}
                      className="rounded-lg mb-2 w-full h-[165px] object-contain"
                    />
                    <div className="font-semibold text-sm text-center line-clamp-2">
                      {video.title}
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* desktop / tablet layout */}
            <div className="row d-none d-md-flex">
              {youtubeVideos.map((video) => (
                <div className="col-md-4 mb-4" key={video.id}>
                  <a
                    href={video.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white rounded-lg d-block h-100 p-0"
                    style={{ transition: "transform .3s" }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(.97)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <img
                      src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                      alt={video.title}
                      className="rounded-lg mb-3 w-100"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="px-2 pb-3">
                      <div className="fw-semibold" style={{ fontSize: "15px" }}>
                        {video.title}
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>

            {/* mobile button */}
            <div className="mt-3 d-md-none text-center">
              <a
                href="https://www.youtube.com/@Bharatdharacares"
                target="_blank"
                rel="noreferrer"
                className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
              >
                Watch all videos →
              </a>
            </div>
          </div>
        </section>

        {/* Reuse existing components */}
        <ServiceListing AllServicesListing={AllServicesListing} />
        <Pricing />
        <PricingComparision />

        {/* Testimonials + Clients */}
        <section className="prt-row testimonials-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="testimonials">
                  <div className="row res-1199-align-center">
                    {/* Avatar Slider */}
                    <div className="col-lg-3 col-md-4">
                      <Slider
                        asNavFor={nav2}
                        ref={slider1}
                        slidesToShow={1}
                        swipeToSlide={true}
                        focusOnSelect={true}
                        vertical={false}
                        arrows={false}
                        infinite={true}
                      >
                        {testimonialAvatars.map((t, idx) => (
                          <div key={idx} className="testimonial-avatar-main">
                            <div className="testimonial-avatar">
                              <div className="testimonial-img">
                                <img
                                  width="180"
                                  height="180"
                                  className="img-fluid"
                                  src={t.img}
                                  alt="testimonial"
                                />
                              </div>
                            </div>
                            <div className="testimonial-caption">
                              <h3>{t.name}</h3>
                              <p>{t.role}</p>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>

                    {/* Text Slider */}
                    <div className="col-lg-9 col-md-8">
                      <Slider
                        asNavFor={nav1}
                        ref={slider2}
                        arrows={false}
                        infinite={true}
                        fade={true}
                        autoplay={true}
                        autoplaySpeed={4000}
                      >
                        {testimonialTexts.map((text, idx) => (
                          <div key={idx} className="testimonials text-center">
                            <div className="testimonial-content">
                              <blockquote className="testimonial-text">
                                {text}
                              </blockquote>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>

                  {/* Clients */}
                  <div className="row mt-5">
                    <div className="col-xl-3 col-lg-12"></div>
                    <div className="col-xl-9 col-lg-12">
                      <div className="client-box-main d-flex flex-wrap">
                        {clients.map((c, idx) => (
                          <div key={idx} className="client-box">
                            <div className="client-thumbnail">
                              <a href="#">
                                <img
                                  width="158"
                                  height="31"
                                  className="img-fluid"
                                  src={c}
                                  alt="client"
                                />
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* End Clients */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="prt-row padding_zero-section cta-section03 animation clearfix">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="cta-content text-center">
                  <div className="section-title title-style-center_text">
                    <div className="title-header">
                      <h2 className="cta-title">Need help choosing a program?</h2>
                      <h3 className="cta-titlepre">
                        Talk to the Dhara team and decide which path fits your
                        current stage.
                      </h3>
                    </div>
                    <div className="cta-bnt mt-40 fadeup-amin">
                      <a
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-darkcolor"
                        href="contact-us.html"
                      >
                        Contact us now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="prt_single_image-wrapper cta-img mt-40 res-991-mt-20"
                  data-cursor-tooltip=""
                >
                  <div className="prt_single_image-wrapper">
                    <a href="team-details.html">
                      <img
                        width="1920"
                        height="400"
                        className="img-fluid"
                        src={CTAImg}
                        alt="cta"
                      />
                    </a>
                  </div>
                  <div className="prt-pfbox-overlay">
                    <div className="ctaimg-title">
                      <a href="team-details.html">
                        Meet our Bharat Dhara Parivar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* cta-section end */}
      </div>
      {/* site-main end */}
    </>
  );
}
